export default __webpack_public_path__ + "static/media/i099jk.4580b23f.webp";